import React from 'react';
import { Translate } from 'react-localize-redux';
import { Link } from 'gatsby';
import styled, { withTheme } from 'styled-components';

export const StyledLink = styled(Link)`
  display: flex;
  padding: 0.9em 0.5em 0.9em ${props => (props.indented ? '3em' : '2em')};
  align-items: center;
  border-bottom: 0.01em rgba(255, 255, 255, 0.9) solid;
  color: inherit;
  text-decoration: none;
  @media (min-width: 768px) {
    font-size: 0.8em;
  }
`;

const Title = styled.div`
  flex: 3;
  font-size: 1.3em;
`;

const Description = styled.div`
  font-size: 0.9em;
  flex: 4;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  ::before {
    content: '-';
  }
  ::after {
    content: '-';
  }
`;

const Item = ({ theme, name, ...rest }) => {
  return (
    <StyledLink
      {...rest}
      activeStyle={{
        background: theme.primary
      }}
    >
      <Title>
        <Translate id={`menu.${name}.title`} />
      </Title>
      <Description>
        <Translate id={`menu.${name}.description`} />
      </Description>
    </StyledLink>
  );
};

export default withTheme(Item);
